const validPhone = (s: string) => {
    const digitMatch = s.match(/\d/g);

    return !((s.length > 50 || !digitMatch || digitMatch.length < 8 || !(/^[\d +]+$/).test(s)));
};

export default validPhone;